import type { RouteObject } from "react-router-dom"

import AccountNavigationLayout from "@layouts/account_navigation_layout"
import AccountPageLayout from "@layouts/account_page_layout"
import AccountProfilePageHeader from "@pages/account/profile/header"
import AccountProfilePasswordPage from "@pages/account/profile/password"
import AccountProfilePasswordPageHeader from "@pages/account/profile/password/header"
import ErrorPage from "@pages/error"

import { AccountProfilePageContextProvider } from "@contexts/account/profile"
import { AccountPasswordPageContextProvider } from "@contexts/account/profile/password"
import AccountProfilePage from "../pages/account/profile/"

const accountNavigation: RouteObject[] = [
  {
    path: "/account/",
    element: <AccountNavigationLayout />,
    errorElement: <ErrorPage />,
    children: [
      {
        path: "profile",
        element: (
          <AccountPageLayout
            HeaderComponent={AccountProfilePageHeader}
            ContextProvider={AccountProfilePageContextProvider}
          >
            <AccountProfilePage />
          </AccountPageLayout>
        )
      },
      {
        path: "profile/password",
        element: (
          <AccountPageLayout
            HeaderComponent={AccountProfilePasswordPageHeader}
            ContextProvider={AccountPasswordPageContextProvider}
          >
            <AccountProfilePasswordPage />
          </AccountPageLayout>
        )
      }
    ]
  }
]

export default accountNavigation
